<ng-content *ngIf="meta; else noMeta"></ng-content>

<ng-template #noMeta>
	<span class="c-error">
		Unable to obtain meta file
	</span>
</ng-template>
